import React from "react";

import { Layout, SpacingSize } from "@multiweb/reactComponents";
import { bemClassNames } from "@multiweb/reactUtils";
import { PlaceholderComponent } from "../../../LiteListFrameGeneralAttributeComponent";

const classNames = bemClassNames("empty-icon-component");

export const LiteListFrameEmptyIconAttributePlaceholder: PlaceholderComponent = () =>
    <span className={classNames()}>
        <Layout spacingSizeHorizontal={SpacingSize.xs} />
    </span>;
